import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { PREVIOUS_ROUTE, REFRESH_TOKEN } from './services/Storage/Constants';
import pipeline from './store/pipeline';
import courses from './store/courses';
import users from './store/users';
import connect from './store/connect';
import utils from './services/utils';
import axiosApi from './services/inteceptor';
import getMachineId from './services/commonMethods';
import { adminnavigation } from '@/utils/Constants/navigationData';
import { _setDataToStorage } from './services/Storage/Functions';

const API_USER_INFO = `${utils.svcUrl()}user-info`;

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    pipeline,
    courses,
    users,
    connect,
  },
  state: {
    loading: false,
    user: null, // firebase user details
    userDetails: null, // database user details
    authorization: '',
    chSubscriptions: [],
    channelType: 'articles',
    customToken: '',
    feedPopup: false,
    navigationList: adminnavigation,
  },
  mutations: {
    async initialiseStore(state) {
      const user = localStorage.getItem('user');
      if (user) {
        state.user = JSON.parse(user);
      }
      const token = localStorage.getItem('token');
      if (token) {
        state.authorization = token;
        axios.defaults.headers.common.Authorization = token;
      }
    },
    toggleLoading(state, payload) {
      state.loading = payload;
    },
    setSignedIn(state, payload) {
      state.user = payload.user; // firebase user details
      if (payload.token) {
        state.authorization = payload.token;
        axios.defaults.headers.common.Authorization = payload.token;
        localStorage.setItem('token', payload.token);
      }
      localStorage.setItem('user', JSON.stringify(state.user));
    },
    setLogout(state) {
      state.user = null;
      state.userDetails = null;
      state.authorization = '';
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('customToken');
      localStorage.removeItem(REFRESH_TOKEN);
      axios.defaults.headers.common.Authorization = '';
      state.customToken = '';
    },
    updateChSubscriptions(state, payload) {
      state.chSubscriptions = payload;
    },
    updateChannelType(state, payload) {
      state.channelType = payload;
    },
    setCustomToken(state, payload) {
      state.customToken = payload;
    },
    removeCustomToken(state) {
      state.customToken = '';
    },
    updateFeedPopup(state, payload) {
      state.feedPopup = payload;
    },
    setUserDetails(state, payload) { // database user details
      state.userDetails = payload; // firebase user details
    },
    setNavigatoinList(state, payload) {
      state.navigationList = payload;
    },
    setActiveTab(state, payload) {
      const tempNavigation = state.navigationList;
      _setDataToStorage(PREVIOUS_ROUTE, payload);
      state.navigationList = tempNavigation.map(nav => ({
        ...nav,
        current: nav.href === payload,
      }));
    },
  },
  actions: {
    getMyDetails: async ({ commit, state }, payload) => {
      try {
        const { uid = state?.user?.uid } = payload;
        const response = await axiosApi.get(API_USER_INFO, {
          params: { userId: uid },
        });
        commit('setUserDetails', response?.data?.user);
        return response?.data?.user;
      } catch (error) {
        commit('setUserDetails', null);
        throw Error(error);
      }
    },
    updateDeviceInfo: async ({ state }, fcmToken) => {
      try {
        console.log(state.user.uid);
        const data = {
          deviceToken: getMachineId(),
          fcmToken,
        };
        const response = await axiosApi.post(`${API_USER_INFO}/update/fcmToken`, data);
        console.log(response);
        return response;
      } catch (error) {
        console.log('update Device info error', error);
        throw Error(error);
      }
    },
  },
});

export default store;
